import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import de from "./locales/de.json";
import en from "./locales/en.json";
import zh from "./locales/zh.json";

const resources = {
  de: { translation: de },
  en: { translation: en },
  zh: { translation: zh },
};

i18n
  .use(LanguageDetector) // Erkennt die Sprache automatisch
  .use(initReactI18next) // Bindet i18next in React ein
  .init({
    resources,
    fallbackLng: "de", // Standard-Sprache
    interpolation: {
      escapeValue: false, // React behandelt das Escaping bereits
    },
  });

export default i18n;
